<header class="flex justify-content-center">
  <img src="assets/images/sparrks.svg" alt="Sparrks logo" style="width: 167px" />
</header>

<table class="paging">
  <thead>
    <tr>
      <td>&nbsp;</td>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td class="print-content">
        <p class="print-title pb-2">
          <ng-container [ngSwitch]="modalWindow">
            <span *ngSwitchCase="'questions'">
              {{ 'LOCALIZE.PREPQUESTIONS' | translate }} | {{ 'LOCALIZE.SESSION' | translate }} {{ sessionNumber }}
            </span>

            <span *ngSwitchCase="'actionItems'">
              {{ 'LOCALIZE.ACTIONITEMS' | translate }} | {{ 'LOCALIZE.SESSION' | translate }} {{ sessionNumber }}
            </span>

            <span *ngSwitchCase="'objectives'">
              {{ 'LOCALIZE.OBJECTIVES' | translate }}
            </span>

            <span *ngSwitchCase="'notes'">
              {{ 'LOCALIZE.NOTES' | translate }}
            </span>

            <span *ngSwitchCase="'keyTakeWays'">
              {{ 'LOCALIZE.KEYTAKEWAYS' | translate }}
            </span>
          </ng-container>
        </p>


        <p class="print-subtitle pb-3 pt-3">
          <span
            *ngIf="modalWindow === 'notes' || modalWindow === 'objectives' || modalWindow === 'actionItems' || modalWindow === 'questions'">
            {{ "LOCALIZE.DATE" | translate }}: {{ currentDate }}
          </span>
          <span *ngIf="modalWindow === 'keyTakeWays'">
            {{ "LOCALIZE.DATECOMPLECTION" | translate }}: {{ dateComplection | date : "dd.MM.yy"}}
          </span>
        </p>
        <table class="header-table">
          <tr>
            <td *ngIf="coach"><span class="info-title">{{'LOCALIZE.COACH' | translate}}:</span> {{coach}}</td>
            <td *ngIf="coachee"><span class="info-title">{{'LOCALIZE.COACHEE' | translate}}:</span> {{coachee}}</td>
            <td><span class="info-title">{{'LOCALIZE.TOPIC' | translate}}:</span> {{topic}}</td>
          </tr>

          <ng-container *ngIf="coach; else coacheeOverview">
            <tr>
              <td><span class="info-title">{{'LOCALIZE.USECASE' | translate}}:</span> {{useCase}}</td>
            </tr>
          </ng-container>

          <ng-template #coacheeOverview>
            <tr>
              <td *ngIf="company"><span class="info-title">{{'LOCALIZE.COMPANY' | translate}}:</span> {{company}}</td>
              <td><span class="info-title">{{'LOCALIZE.USECASE' | translate}}:</span> {{useCase}}</td>
            </tr>
            <tr>
              <td *ngIf="preferedLanguage"><span class="info-title">{{'LOCALIZE.LANGUAGE' | translate}}:</span>
                {{preferedLanguage}}</td>
            </tr>
          </ng-template>
        </table>

        <div *ngFor="let item of data; index as i" class="position-relative print-element">
          <span class="print-index"> {{ i + 1 }}. </span>
          <div *ngIf="modalWindow === 'keyTakeWays'">
            <div class="print-text text-space">
              {{ item.key_takeaway }}
            </div>
          </div>
          <div *ngIf="modalWindow === 'actionItems'">
            <div class="print-text text-space">
              {{ item.action_item }}
            </div>
          </div>

          <div *ngIf="modalWindow === 'questions'">
            <div class="print-label pb-1">
              {{ item.question }}
            </div>
            <div class="print-text text-space" #printText [ngStyle]="{'padding-bottom.px': textPadding[i]}">
              {{ item.answer }}
            </div>
          </div>

          <hr class="primary-line" />
        </div>
        <div *ngIf="modalWindow === 'objectives'" class="position-relative print-element">
          <div class="print-text">
            {{ data }}
          </div>
        </div>
        <div *ngIf="modalWindow === 'notes'" class="position-relative print-element">
          <div class="print-text" [innerHTML]="data"></div>
        </div>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td>&nbsp;</td>
    </tr>
  </tfoot>
</table>

<footer>
  <div class="row footer-block">
    <div class="qr-block col-4 align-items-end d-flex">
      <div class="shape path">
        <svg width="79.959" xmlns="http://www.w3.org/2000/svg" height="79.959"
          id="screenshot-224dd769-a3ac-80bf-8004-ed22f09eb08d" viewBox="350.25 1382 79.959 79.959" fill="none"
          version="1.1">
          <g id="shape-224dd769-a3ac-80bf-8004-ed22f09eb08d" data-testid="svg-path">
            <defs></defs>
            <g class="fills" id="fills-224dd769-a3ac-80bf-8004-ed22f09eb08d">
              <path
                d="M350.250,1382.000L350.250,1408.653L376.903,1408.653L376.903,1382.000L350.250,1382.000ZZM384.518,1382.000L384.518,1389.615L380.710,1389.615L380.710,1393.423L384.518,1393.423L384.518,1397.230L388.326,1397.230L388.326,1401.038L392.133,1401.038L392.133,1404.845L395.941,1404.845L395.941,1412.461L399.748,1412.461L399.748,1416.268L395.941,1416.268L395.941,1412.461L388.326,1412.461L388.326,1408.653L384.518,1408.653L384.518,1404.845L380.710,1404.845L380.710,1412.461L365.480,1412.461L365.480,1416.268L369.288,1416.268L369.288,1423.883L361.673,1423.883L361.673,1420.076L365.480,1420.076L365.480,1416.268L361.673,1416.268L361.673,1412.461L350.250,1412.461L350.250,1416.268L357.865,1416.268L357.865,1423.883L361.673,1423.883L361.673,1427.691L365.480,1427.691L365.480,1431.498L380.710,1431.498L380.710,1446.729L384.518,1446.729L384.518,1450.536L395.941,1450.536L395.941,1461.959L403.556,1461.959L403.556,1458.151L399.748,1458.151L399.748,1454.344L403.556,1454.344L403.556,1450.536L407.363,1450.536L407.363,1454.344L411.171,1454.344L411.171,1461.959L418.786,1461.959L418.786,1458.151L414.978,1458.151L414.978,1442.921L411.171,1442.921L411.171,1439.114L414.978,1439.114L414.978,1442.921L418.786,1442.921L418.786,1439.114L414.978,1439.114L414.978,1435.306L418.786,1435.306L418.786,1439.114L426.401,1439.114L426.401,1442.921L430.209,1442.921L430.209,1427.691L426.401,1427.691L426.401,1431.498L422.594,1431.498L422.594,1435.306L418.786,1435.306L418.786,1427.691L411.171,1427.691L411.171,1431.498L407.363,1431.498L407.363,1442.921L411.171,1442.921L411.171,1450.536L407.363,1450.536L407.363,1446.729L395.941,1446.729L395.941,1442.921L399.748,1442.921L399.748,1435.306L403.556,1435.306L403.556,1427.691L399.748,1427.691L399.748,1431.498L392.133,1431.498L392.133,1439.114L388.326,1439.114L388.326,1435.306L384.518,1435.306L384.518,1431.498L388.326,1431.498L388.326,1427.691L384.518,1427.691L384.518,1423.883L388.326,1423.883L388.326,1427.691L392.133,1427.691L392.133,1423.883L388.326,1423.883L388.326,1416.268L392.133,1416.268L392.133,1423.883L399.748,1423.883L399.748,1420.076L403.556,1420.076L403.556,1416.268L407.363,1416.268L407.363,1412.461L399.748,1412.461L399.748,1404.845L395.941,1404.845L395.941,1401.038L392.133,1401.038L392.133,1397.230L388.326,1397.230L388.326,1389.615L392.133,1389.615L392.133,1393.423L395.941,1393.423L395.941,1397.230L399.748,1397.230L399.748,1393.423L395.941,1393.423L395.941,1385.808L388.326,1385.808L388.326,1382.000L384.518,1382.000ZZM395.941,1382.000L395.941,1385.808L399.748,1385.808L399.748,1382.000L395.941,1382.000ZZM403.556,1382.000L403.556,1408.653L430.209,1408.653L430.209,1382.000L403.556,1382.000ZZM373.095,1385.808L373.095,1404.845L354.057,1404.845L354.057,1385.808L373.095,1385.808ZZM426.401,1385.808L426.401,1404.845L407.363,1404.845L407.363,1385.808L426.401,1385.808ZZM357.865,1389.615L357.865,1401.038L369.288,1401.038L369.288,1389.615L357.865,1389.615ZZM411.171,1389.615L411.171,1401.038L422.594,1401.038L422.594,1389.615L411.171,1389.615ZZM388.326,1404.845L388.326,1408.653L392.133,1408.653L392.133,1404.845L388.326,1404.845ZZM418.786,1412.461L418.786,1416.268L422.594,1416.268L422.594,1412.461L418.786,1412.461ZZM376.903,1416.268L376.903,1420.076L373.095,1420.076L373.095,1416.268L376.903,1416.268ZZM384.518,1416.268L384.518,1420.076L380.710,1420.076L380.710,1416.268L384.518,1416.268ZZM411.171,1416.268L411.171,1420.076L407.363,1420.076L407.363,1423.883L414.978,1423.883L414.978,1420.076L418.786,1420.076L418.786,1423.883L430.209,1423.883L430.209,1416.268L426.401,1416.268L426.401,1420.076L418.786,1420.076L418.786,1416.268L411.171,1416.268ZZM350.250,1423.883L350.250,1431.498L354.057,1431.498L354.057,1423.883L350.250,1423.883ZZM376.903,1423.883L376.903,1427.691L373.095,1427.691L373.095,1423.883L376.903,1423.883ZZM350.250,1435.306L350.250,1461.959L376.903,1461.959L376.903,1435.306L350.250,1435.306ZZM373.095,1439.114L373.095,1458.151L354.057,1458.151L354.057,1439.114L373.095,1439.114ZZM357.865,1442.921L357.865,1454.344L369.288,1454.344L369.288,1442.921L357.865,1442.921ZZM388.326,1446.729L384.518,1446.729L384.518,1439.114L388.326,1439.114L388.326,1446.729ZZM422.594,1442.921L422.594,1446.729L418.786,1446.729L418.786,1450.536L426.401,1450.536L426.401,1454.344L430.209,1454.344L430.209,1450.536L426.401,1450.536L426.401,1442.921L422.594,1442.921ZZM380.710,1450.536L380.710,1461.959L384.518,1461.959L384.518,1458.151L388.326,1458.151L388.326,1454.344L384.518,1454.344L384.518,1450.536L380.710,1450.536ZZM422.594,1454.344L422.594,1461.959L430.209,1461.959L430.209,1458.151L426.401,1458.151L426.401,1454.344L422.594,1454.344ZZ"
                style="
                  fill-rule: evenodd;
                  clip-rule: evenodd;
                  stroke-linejoin: round;
                  stroke-miterlimit: 2;
                  fill: #767676;
                  fill-opacity: 1;
                "></path>
            </g>
          </g>
        </svg>
        <p class="text-footer">app.sparrks.io</p>
      </div>
    </div>
    <div class="footer-column col-4">
      <p class="text-footer">
        {{ "LOCALIZE.HAVE_QUESTIONS" | translate }}
      </p>
      <hr class="short-line" />
      <p class="text-footer">
        <i class="bx bx-phone primary-color"></i>
        <span>+49 (0)30 52014961</span>
      </p>
      <p class="text-footer">
        <i class="bx bx-envelope primary-color"></i>
        <span>info&#64;sparrks.de</span>
      </p>
    </div>
    <div class="footer-column col-4 align-items-end d-flex">
      <p class="text-footer">SPARRKS Service GmbH, {{ year }}</p>
    </div>
  </div>
</footer>
